module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkinsHolder"
  }, [(!_vm.audienceTypes) ? _c('div', {
    staticClass: "row"
  }, [_vm._v("\n        loading\n    ")]) : _vm._e(), _vm._v(" "), (_vm.reservation.billing && _vm.audienceTypes) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 bg-lighter border-right-light py-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between font-weight-600 mb-2"
  }, [_c('span', [_vm._v("Total Pax:")]), _c('span', [_vm._v(_vm._s(_vm.totalPax))])]), _vm._v(" "), (_vm.reservation.bookingGenderPrices.length > 0) ? _vm._l((_vm.reservation.bookingGenderPrices), function(personPrice, index) {
    return (personPrice.audienceType) ? _c('div', {
      staticClass: "d-flex flex-column justify-content-between fs-small align-items-center my-1"
    }, [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.genderPriceObj(personPrice).description),
        expression: "genderPriceObj(personPrice).description"
      }],
      staticClass: "w-100"
    }, [_vm._v(_vm._s(_vm.genderPriceObj(personPrice).name) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "w-100 d-flex justify-content-between align-items-center"
    }, [(_vm.audienceTypes) ? _c('span', {}, [(_vm.genderPriceObj(personPrice).description) ? _c('div', [_vm._v(_vm._s(_vm.genderPriceObj(personPrice).description) + ":")]) : _vm._e(), _vm._v(" "), (_vm.showPrice) ? _c('div', {
      staticClass: "fs-smallest dark"
    }, [_vm._v("(" + _vm._s(_vm.formatPrice(_vm.showTicketPrice(personPrice))) + "€)")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.editingPax) ? _c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v("\n                            " + _vm._s(personPrice.quantityToBook) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (_vm.editingPax) ? _c('div', {
      staticClass: "paxQtdEditor font-weight-600 w-100 mt-1 text-center"
    }, [_c('span', {
      staticClass: "bg-lightest border-medium radius-normal p-1 pointer",
      on: {
        "click": function($event) {
          return _vm.changePax('subtract', personPrice)
        }
      }
    }, [_c('i', {
      staticClass: "m-0 ico ico-minus fs-smallest"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (personPrice.quantityToBook),
        expression: "personPrice.quantityToBook",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "px-0 py-1 text-center",
      staticStyle: {
        "width": "28px"
      },
      attrs: {
        "disabled": _vm.disabled,
        "readonly": "",
        "type": "number"
      },
      domProps: {
        "value": (personPrice.quantityToBook)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(personPrice, "quantityToBook", _vm._n($event.target.value))
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          return _vm.paxManuallyChanged(personPrice)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "bg-lightest border-medium radius-normal p-1 pointer",
      on: {
        "click": function($event) {
          return _vm.changePax('add', personPrice)
        }
      }
    }, [_c('i', {
      staticClass: "m-0 ico ico-add fs-smallest"
    })])]) : _vm._e()]) : _vm._e()
  }) : _vm._e(), _vm._v(" "), (_vm.reservation.bookingGenderPrices.length > 0 && !_vm.isPerOrderWithoutParticipants) ? _c('div', {
    staticClass: "mt-2",
    class: {
      'opacity-50': _vm.isReservationReadOnly
    }
  }, [(_vm.showEditPax) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleEditPax
    }
  }, [_vm._v(_vm._s(_vm.editingPax ? 'Apply' : 'Edit'))]) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 p-2",
    class: {
      'opacity-50': !_vm.checkinAllowed
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "dark pt-2"
  }, [_vm._v("\n                    Check-In\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.decrementCheckin
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.paxCheckedIn),
      expression: "reservation.paxCheckedIn"
    }],
    staticClass: "text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.reservation.paxCheckedIn)
    },
    on: {
      "blur": _vm.checkinBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "paxCheckedIn", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.incrementCheckin
    }
  }, [_vm._v(" + ")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('div', {
    staticClass: "dark pt-2"
  }, [_vm._v("\n                    No-Show\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.decrementNoShow
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.paxNoShow),
      expression: "reservation.paxNoShow"
    }],
    staticClass: "text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.reservation.paxNoShow)
    },
    on: {
      "blur": _vm.noShowBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "paxNoShow", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.incrementNoShow
    }
  }, [_vm._v(" + ")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [(_vm.totalPax == 0) ? _c('span', {
    staticClass: "bold dark",
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("No Pax selected")]) : (!_vm.allChecked) ? _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("Check-in All")]) : (_vm.allChecked) ? _c('button', {
    staticClass: "btn tertiary",
    class: _vm.checkinAllButton,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("All checked "), _c('i', {
    staticClass: "ico ico-check mr-0 ml-2"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.checkinAllowed) ? _c('div', {
    staticClass: "col-sm-12 py-3 text-center"
  }, [(_vm.isReservationReadOnly) ? _c('span', [_vm._v("Booking read only")]) : (_vm.totalDue > 0) ? _c('span', [_vm._v("Booking not paid")]) : _vm._e()]) : _vm._e()])]) : _c('div', {
    staticClass: "dark text-center m-3"
  }, [_c('div', {
    staticClass: "fs-large darker"
  }, [_vm._v("Loading")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23de2f94"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabDetails/Checkins.vue
// module id = 1644
// module chunks = 0